import React from "react";

const ListInput = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-wrap",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      {label}
      <div className={divClass}>
        <input name={name} id={props?.id ?? name} type="text" {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default ListInput;
